export enum Grade {
  AVAL = 5,
  DOVOM = 6,
  SEVOM = 7,
  CHAHAROM = 8,
  PANJOM = 9,
  SHISHOM = 10,
  SHISHOM_TIZHOUSHAN = 26,
  HAFTOM = 11,
  HASHTOM = 12,
  NOHOM = 13,
  NOHOM_TIZHOUSHAN = 27,
  DAHOM = 14,
  DAHOM_KONKOUR = 22,
  DAHOM_NAHAEI = 31,
  YAZDAHOM = 15,
  YAZDAHOM_KONKOUR = 23,
  YAZDAHOM_NAHAEI = 32,
  DAVAZDAHOM = 16,
  DAVAZDAHOM_KONKOUR = 24,
  DAVAZDAHOM_NAHAEI = 33,
}
